import { get } from "lodash-es";
import { defineStore } from "pinia";

import { getSessionItem, setSessionItem } from "@/api/biz/common";
import { getChannelDetail, getChannelRaw } from "@/api/channel";
// import { getConsumerChannel } from "@/api/render";
import { store } from "@/store";

export const useChannelStore = defineStore({
  id: "sys-channel",
  state: () => ({
    channel: null,
    channelCharmdeer: null,
    isCharmdeer: false
  }),
  actions: {
    SET_CHANNEL(channels) {
      this.channelCharmdeer = channels.find(item => item.key === "charmdeer");
      this.channel =
        channels.find(item => item.key !== "charmdeer") ||
        this.channelCharmdeer;
      this.isCharmdeer = this.channel?.key === "charmdeer";
      if (this.channel?.key) {
        this.setSessionChannel();
      }
    },
    async getChannel(key) {
      this.getChannelByKey(key);
    },
    clear() {
      this.channelCharmdeer = null;
      this.channel = null;
    },
    async getChannelById(id) {
      const res = await getChannelDetail(id);
      this.SET_CHANNEL([res]);
    },
    async getChannelByKey(key) {
      if (key) {
        localStorage.setItem("sys-channel", key);
      }
      key = key || localStorage.getItem("sys-channel");
      const res = await getChannelRaw(key);
      this.SET_CHANNEL(res);
    },
    async getSessionChannel() {
      const session = await getSessionItem("sys-channel");
      const channel = get(session, "value.channel");
      return channel;
    },
    async setSessionChannel() {
      setSessionItem({
        key: "sys-channel",
        value: {
          channel: this.channel?.key
        }
      });
    }
  },
  getters: {
    isHoteLuxPlatform: state => {
      return ["hotelux", "hoteluxjp"].includes(state.channel?.key);
    },
    isSubMerchant: state => {
      return ["dbs", "hlgp", "dc"].includes(state.channel?.key);
    }
  }
});

export function useChannelStoreHook() {
  return useChannelStore(store);
}
